import { render, staticRenderFns } from "./welcome-integrations.vue?vue&type=template&id=6a8d0963&scoped=true&"
import script from "./welcome-integrations.vue?vue&type=script&lang=js&"
export * from "./welcome-integrations.vue?vue&type=script&lang=js&"
import style0 from "./welcome-integrations.vue?vue&type=style&index=0&id=6a8d0963&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a8d0963",
  null
  
)

export default component.exports